module.exports = __webpack_public_path__ + "static/media/play-audio.d1df67d2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/play-audio.mp3
// module id = 37
// module chunks = 1